import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {ScoutFactory} from "@/modules/scouting/factories/ScoutFactory";
import {AfterCreateGameEvent} from "@/modules/base/events/AfterCreateGameEvent";
import {NotificationFactory} from "@/modules/youth/factories/NotificationFactory";
import {Team} from "@/modules/team/entity";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@injectable()
export class SeederEventSubscriber implements EventSubscriber {
  constructor(
    @inject(ConfigRepository) protected configRepository: ConfigRepository,
    @inject(ScoutFactory) private scoutFactory: ScoutFactory,
    @inject(NotificationFactory) private notificationFactory: NotificationFactory,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterCreateGameEvent, callback: this.onAfterCreateGameEvent},
    ];
  }

  async onAfterCreateGameEvent(event: AfterCreateGameEvent): Promise<void> {
    const team = await Team.current();

    await times(1).forEachAsync(async () => {
      const scout = await this.scoutFactory.generate();
      scout.team = team;
      await scout.save();
    });

    if (this.configRepository.get('debug')) {
      await this.notificationFactory.generate(team, 7);
    }
  }
}